"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var enums_1 = require("../enums");

var evaluateStringVariable_1 = require("./evaluateStringVariable");

exports.evaluateVideoSource = function (videoSource, variableDictionary) {
  switch (videoSource.type) {
    // With variables
    case enums_1.VideoSourceType.S3:
      {
        return {
          type: videoSource.type,
          frameRate: videoSource.frameRate,
          isPrivate: videoSource.isPrivate,
          s3Bucket: evaluateStringVariable_1.evaluateStringVariable(videoSource.s3Bucket, variableDictionary),
          s3Key: evaluateStringVariable_1.evaluateStringVariable(videoSource.s3Key, variableDictionary),
          s3Region: videoSource.s3Region ? evaluateStringVariable_1.evaluateStringVariable(videoSource.s3Region, variableDictionary) : undefined
        };
      }

    case enums_1.VideoSourceType.Url:
      {
        return {
          type: videoSource.type,
          frameRate: videoSource.frameRate,
          source: evaluateStringVariable_1.evaluateStringVariable(videoSource.source, variableDictionary)
        };
      }
  }
};